import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import "./SubNav.css";

const SubNav = props => {
  const { links, isMobile } = props;

  const subNavStyles = cx({
    "d-flex": true,
    "flex-frw": true,
    "pad-0": true,
    "ff-ns": true,
    "fs-16": true,
    "fw-400": true,
    "sub-nav": true,
    "flex-jse": isMobile,
    mobile: isMobile,
    "lh-lg": isMobile
  });

  return (
    <ul className={subNavStyles}>
      {links.map((link, ind) => {
        return (
          <li className="t-ws-nowrap" key={link.title}>
            <a alt={link.title} href={link.url} className={link.className}>
              {link.title}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default SubNav;

SubNav.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};



// WEBPACK FOOTER //
// ./src/Components/Header/SubNav/SubNav.js